import {
  TENANT_AT,
  TENANT_CH,
  TENANT_COM,
  TENANT_FR,
  TENANT_IT,
} from 'shared/consts'

import type { TenantBasedExperiment } from './types'

export const SERP_PRE_QUERY_SUGGESTIONS_PER_TENANT_EXPERIMENT = {
  [TENANT_COM]: { desktop: 'cro-2500', mobile: 'cro-2501' },
  [TENANT_AT]: { desktop: 'cro-2484', mobile: 'cro-2485' },
  [TENANT_FR]: { desktop: 'cro-2491', mobile: 'cro-2492' },
  [TENANT_IT]: { desktop: 'cro-2489', mobile: 'cro-2490' },
  [TENANT_CH]: { desktop: 'cro-2493', mobile: 'cro-2494' },
}

export const AFTER_QUERY_SUGGEST_LAYER = {
  [TENANT_COM]: { desktop: 'cro-2734', mobile: 'cro-2735' },
  [TENANT_AT]: { desktop: 'cro-2737', mobile: 'cro-2736' },
  [TENANT_FR]: { desktop: 'cro-2745', mobile: 'cro-2744' },
  [TENANT_IT]: { desktop: 'cro-2742', mobile: 'cro-2743' },
  [TENANT_CH]: { desktop: 'cro-2746', mobile: 'cro-2747' },
}

export const HEADER_LABELS = {
  [TENANT_COM]: { desktop: 'cro-3165' },
  [TENANT_AT]: { desktop: 'cro-3166' },
  [TENANT_FR]: { desktop: 'cro-3168' },
  [TENANT_IT]: { desktop: 'cro-3167' },
  [TENANT_CH]: { desktop: 'cro-3169' },
}

export const ALGOLIA_NEURAL_SEARCH_PER_TENANT_EXPERIMENT: TenantBasedExperiment =
  {
    [TENANT_COM]: {
      desktop: 'cro-3134',
      mobile: 'cro-3134',
    },
    [TENANT_IT]: {
      desktop: 'cro-3131',
      mobile: 'cro-3131',
    },
    [TENANT_FR]: {
      desktop: 'cro-3130',
      mobile: 'cro-3130',
    },
    [TENANT_AT]: {
      desktop: 'cro-3133',
      mobile: 'cro-3133',
    },
    [TENANT_CH]: {
      desktop: 'cro-3135',
      mobile: 'cro-3135',
    },
  }

export const CARTINTERMEDIATE_ERX_BANNER: TenantBasedExperiment = {
  [TENANT_COM]: { desktop: 'cro-2940', mobile: 'cro-2941' },
}

export const EXIT_INTENT_POPUP_EXPERIMENT = {
  [TENANT_COM]: { desktop: 'cro-3102', mobile: 'cro-3103' },
  [TENANT_AT]: { desktop: 'cro-3105', mobile: 'cro-3104' },
  [TENANT_FR]: { desktop: 'cro-3109', mobile: 'cro-3108' },
  [TENANT_IT]: { desktop: 'cro-3106', mobile: 'cro-3107' },
  [TENANT_CH]: { desktop: 'cro-3110', mobile: 'cro-3111' },
}
